import { render } from "./ConfirmationAccount.vue?vue&type=template&id=334c33c4"
import script from "./ConfirmationAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmationAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__